import React from 'react';
import style from '../../PaperworkList/PaperworkList.module.css';
import s from '../ProductReport.module.css';
import {MovementsType} from '../../../types/StoreReportTypes';
import {Link} from 'react-router-dom';
type Props = {
	product: MovementsType;
};
const NowNameTableRowEl: React.FC<Props> = ({product}) => {
	const {order_id, img, name, order_date, count, type} = product;
	return (
		<div className={`${style.tableRow} ${s.tableRow}`}>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				<img src={img} alt={name} />
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>{name}</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{order_date}
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>{count}</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{/*{movementsStatusTranslate('')}*/}
				<Link
					state={{
						defaultFilters: {
							filter_active: true,
							order_id: order_id,
						},
					}}
					to={
						type === 'Оформлення'
							? '/paperwork_list'
							: type === 'Замовлення'
								? '/list_of_invoices'
								: ''
					}
				>
					{type} № {order_id}
				</Link>
			</div>
		</div>
	);
};

export default NowNameTableRowEl;
